import { gql } from '@apollo/client'

export const NOTIFICATIONS_QUERY = gql`
  query notifications($read: Boolean, $page: Int, $perPage: Int) {
    notifications(read: $read, page: $page, perPage: $perPage) {
      id
      notificationType
      title
      body
      metadata
      read
      readAt
      createdAt
    }
  }
`
